import { motion } from "framer-motion";
import { Bed, UtensilsCrossed, Wifi, Shield, Clock, Users } from "lucide-react";

const features = [
  {
    icon: Bed,
    title: "Comfortable Beds",
    description: "Clean, cozy beds with fresh linens for a restful sleep",
  },
  {
    icon: UtensilsCrossed,
    title: "All Meals Included",
    description: "Breakfast, lunch, and dinner - no hidden costs",
  },
  {
    icon: Wifi,
    title: "High-Speed WiFi",
    description: "Stay connected with fast and reliable internet",
  },
  {
    icon: Shield,
    title: "Safe & Secure",
    description: "24/7 security and verified properties for peace of mind",
  },
  {
    icon: Clock,
    title: "Flexible Check-in",
    description: "Early check-in and late check-out options available",
  },
  {
    icon: Users,
    title: "Community Living",
    description: "Meet fellow travelers and make lasting connections",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Why Choose <span className="text-primary">Social Bunkr</span>?
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Everything you need for a comfortable and affordable stay
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="group"
            >
              <div className="bg-card border border-border rounded-2xl p-8 h-full hover:shadow-xl transition-all duration-300 hover:border-primary/30">
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                  <feature.icon className="w-7 h-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <h3 className="text-xl font-semibold text-card-foreground mb-3">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
